'use es6';

import { Map as ImmutableMap } from 'immutable';
import settled from '../lib/settled';
export const combine = (...getters) => (...args) => settled(getters.map(getter => getter(...args))).then(resolves => resolves.filter(({
  state
}) => state === 'fulfilled').map(({
  value
}) => value).reduce((merged, references) => merged.mergeDeep(references), ImmutableMap()));